<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('paymentAdjustment.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('paymentAdjustment.pageTitle'),
            href: '/payment-adjustments'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-6">
            <SearchInvoice @invoice="onReceiveInvoiceClick" />
          </div>
          <div class="col-md-6">
            <FormV2
              v-model="model"
              ref="formV2"
              :validate="errors"
              :invoice="invoice"
            />
          </div>
        </div>
        <div class="row ts-mt-5">
          <div class="col-md-12">
            <h1 class="ts-text-lg ts-text-gray-600">
              {{ $t('paymentAdjustment.invoiceItem') }}
            </h1>
            <InvoiceItemDetail
              :validate="errors"
              v-model="model"
              ref="invoiceDetail"
            />
            <div class="validate" v-if="errors.has('inv_detail_list')">
              {{ errors.first('inv_detail_list') }}
            </div>
          </div>
        </div>
        <div class="row ts-mt-5">
          <div class="col-md-12 ts-flex ts-justify-end ts-space-x-2">
            <ts-button @click="$router.push({ name: 'payment-adjustment' })">{{
              $t('cancel')
            }}</ts-button>
            <ts-button
              color="info"
              outline
              :waiting="loading"
              @click.prevent="onSave"
              >{{ $t('save_add_new') }}</ts-button
            >
            <ts-button
              color="primary"
              :waiting="loading"
              @click.prevent="onSave"
              >{{ $t('save') }}</ts-button
            >
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>

    <a-modal
      width="50%"
      centered
      v-model="print_pdf"
      :title="$t('pdf')"
      :maskClosable="false"
      :footer="null"
      :zIndex="1020"
      @cancel="closePDFmodal"
    >
      <pdf-preview :src="src" :waiting="waiting" height="70vh" mspin="30vh" />
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import PdfPreview from './components/pdf_preview'
import SearchInvoice from './components/search-invoice.vue'
import FormV2 from './components/formV2.vue'
import InvoiceItemDetail from './components/invoice-item-detail.vue'
// import EnrollConfirm from './components/enroll-confirm.vue'
import { mapActions } from 'vuex'
export default {
  name: 'invoiceAdjustmentCreate',
  components: {
    SearchInvoice,
    FormV2,
    InvoiceItemDetail,
    PdfPreview
    // EnrollConfirm
  },
  data() {
    return {
      loading: false,
      errors: new Errors(),
      invoice: {},
      print_pdf: false,
      waiting: false,
      src: '',
      model: {
        adjustment_id: undefined,
        adj_date: moment().format('DD-MM-YYYY'),
        inv_id: null,
        new_inv_amount: 0,
        adj_amount: 0,
        next_payment_date: undefined,
        descriptions: '',
        new_class_id: '',
        ac_st_id: null,
        session: [],
        inv_detail_list: [],
        bank_id: null,
        payment_method_id: 1,
        student_id: '',
        is_print: false,
        need_enroll: false
      }
    }
  },
  methods: {
    ...mapActions('paymentAdjustment', ['store']),
    onReceiveInvoiceClick(invoice) {
      this.invoice = invoice
      this.model.inv_id = invoice.inv_id
      this.model.student_id = invoice.student_id
      this.$refs.invoiceDetail.fetchInvoiceDetail()
      this.$refs.formV2.fetchNewClass(this.invoice.acp_id)
    },
    onSave() {
      // if (this.model.need_enroll) {
      //   this.$confirm({
      //     content: h =>
      //       h(EnrollConfirm, {
      //         props: {
      //           value: this.model
      //         }
      //       }),
      //     footer: null,
      //     centered: true,
      //     closable: true,
      //     okText: this.$t('submit'),
      //     onOk: () => {
      //       return this.actionSave(!this.model.is_print)
      //     },
      //     onCancel: () => {}
      //   })
      //   return
      // } else {
      // }
      this.actionSave(!this.model.is_print)
    },
    actionSave(pushBack = false) {
      this.loading = true
      this.waiting = this.model.is_print
      this.print_pdf = this.model.is_print
      return this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          if (this.model.is_print) {
            this.src = response.url
            this.clearInput()
          } else if (pushBack) {
            this.$router.push({ name: 'payment-adjustment' })
          }

          return new Promise(r => r('done'))
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          return Promise.reject(error)
        })
        .finally(() => {
          this.loading = false
          this.waiting = false
        })
    },
    clearInput() {
      this.model.adjustment_id = undefined
      this.model.adj_date = moment().format('DD-MM-YYYY')
      this.model.inv_id = null
      this.model.new_inv_amount = 0
      this.model.adj_amount = 0
      this.model.next_payment_date = undefined
      this.model.descriptions = ''
      this.model.new_class_id = ''
      this.model.ac_st_id = null
      this.model.session = []
      this.model.student_id = ''
      this.model.inv_detail_list = []
      this.model.bank_id = null
      this.model.payment_method_id = 1
      this.model.is_print = false
    },
    closePDFmodal() {
      this.print_pdf = false
      this.src = null
    }
  }
}
</script>
